import { BlobTypeEnum } from "../enums/blob-type.enum";

export class DownloadDocumentViewModel {
    Id: number;
    BlobTypeEnum: BlobTypeEnum;
}